import './App.css';
import React, { useState, useEffect } from 'react'
import { MeiliSearch } from 'meilisearch'
import Item from './components/Item'

const client = new MeiliSearch({
  host: 'https://app.dealerbi.com/search-api-ms/',
  apiKey: 'f69a5a51033a4156a20db52234d0869b',
})

const index = client.index('dealerbi-dashboards')

function App() {

  const [searchedWord, setSearch] = useState('')
  const [resultSearch, setResults] = useState([])

  useEffect(() => {
    // Create an scoped async function in the hook
    async function searchWithMeili () {
      const search = await index.search(searchedWord, {
        limit: 1000,
        attributesToHighlight: ['name']
      })
      setResults(search.hits)
    }    
    // Execute the created function directly
    searchWithMeili()
  }, [searchedWord])

  return (
    <div class="row pb-2 pb-sm-4">
      {/* <!-- Product grid--> */}
      <div class="col-lg-12">
          {/* <!--serach here --> */}
          <div class="d-flex align-items-start justify-content-between mb-4">
            <form class="position-relative w-100 mt-2 mb-4">
                <i class="ai-search fs-xl position-absolute top-50 start-0 translate-middle-y ms-3" role="button"></i>
                <input class="form-control form-control-lg px-5" type="search" id="searchinput" value={searchedWord}
                onChange={(event) => setSearch(event.target.value)}
                placeholder='Product, sport, color, …'/>
            </form>
          </div>
            {/* <!-- Item--> */}    
            <div className='searchResults'>
              <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
                {/* <!--ADD CLASSES HERE d-flex align-items-stretch--> */}
                  {
                  resultSearch?.map((result) => (
                  <Item
                    url={result.url}
                    image={result.images}
                    name={result.title}
                    category={result.description}
                    pageid={result.id}
                    content={result.content}
                    key={result.id}
                  />
                ))}
              </div>
            </div>
      </div>
  </div>
  );
}

export default App;
